import {Request} from '@group-devs/yfp7-global-modules'
import {FaCalendarAlt, FaChevronDown} from "react-icons/fa";
import {Nav, NavDropdown, Image} from 'react-bootstrap'
import {useState} from 'react'
import {WSectionsNav, WCategoriesNav} from '../Block'
import Link from 'next/link'
import {RightSectionNav} from '@group-devs/yfp7-global-modules/components/Block'

const request = new Request(process.env.apiDomain)

const WellnessFooterNav = (props) => {
    const {data: hub} = request.website.swrSite(props.site.accountId, "HUB")
    const [bg, setBg] = useState(false)
    const delay = () => {
        if (bg == true){
            setTimeout(() => {
                setBg(!bg)
            }, 300)
        } else {
            setBg(!bg)
        }
    }

    return (
        <Nav className="dashboardfooternav d-lg-none d-flex text-center">
            <Link href="/home" passHref><Nav.Link>
                <svg width="46" height="46">
                    <path d="M35.18,22.37l-4.44-4.43V13.48A.78.78,0,0,0,30,12.7H27.5a.78.78,0,0,0-.78.78v.46L24.3,11.52l-.83-.82a.54.54,0,0,0-.76,0l-.83.82L11,22.37a.85.85,0,0,0,1.21,1.2l1.09-1.09V34.26a.47.47,0,0,0,.48.47h7.53a.35.35,0,0,0,.35-.35V28.33h2.78v6.05a.35.35,0,0,0,.35.35h7.56a.47.47,0,0,0,.47-.47V22.43L34,23.57a.86.86,0,0,0,1.21,0h0A.85.85,0,0,0,35.18,22.37Zm-7.37-8.58h1.84v3.07L27.81,15ZM31.13,33h-5V28.33h0V27.27a.63.63,0,0,0-.63-.63H20.6a.63.63,0,0,0-.63.63v1.06h0V33H15V20.8l8.1-8.07,3.63,3.61,1.09,1.09,1.47,1.46,1,1,.84.84Z"/>
                </svg>
                <span className="footer-link">Home</span>
            </Nav.Link></Link>
            <WSectionsNav site={props.site} />
            <WCategoriesNav site={props.site} />
            {hub ? <Nav.Link href={`//${hub.url}/events`} target="_blank">
                <svg width="46" height="46">
                    <path d="M32.88,13.45H29.56V11.89a.77.77,0,1,0-1.53,0v1.56H23.87V11.89a.77.77,0,1,0-1.53,0v1.56H18.15V11.89a.77.77,0,1,0-1.53,0v1.56H13.3a1.69,1.69,0,0,0-1.7,1.69V32.4a1.69,1.69,0,0,0,1.7,1.69H32.88a1.69,1.69,0,0,0,1.7-1.69V15.14A1.69,1.69,0,0,0,32.88,13.45ZM32.46,32H13.72V15.56h2.9v.81a.77.77,0,0,0,1.53,0v-.81h4.19v.81a.77.77,0,0,0,1.53,0v-.81H28v.81a.77.77,0,0,0,1.53,0v-.81h2.9Zm-15.76-10h2.91v-2H16.7Zm4.95,0h2.91v-2H21.65Zm4.92,0h2.91v-2H26.57ZM16.7,25.43h2.91v-2H16.7Zm4.95,0h2.91v-2H21.65Zm4.92,0h2.91v-2H26.57ZM16.7,28.91h2.91v-2H16.7Zm4.95,0h2.91v-2H21.65Zm4.92,0h2.91v-2H26.57Z"/>
                </svg>
                <span className="footer-link">Events</span>
            </Nav.Link> : null}
            
            <style jsx global>{`

                .dashboardfooternav {
                    justify-content: space-evenly!important;
                }
                
                .dashboardfooternav .nav-link{
                    padding: 0 0 4px 0;
                    color: #fff;
                }
                
                .dashboardfooternav .nav-link svg path{
                    fill: #fff;
                }
                
                .dashboardfooternav .nav-link .footer-link{
                    font-size: 8px;
                    margin-top: -5px;
                    display: block;
                }
                
                @media(max-width:991.98px){

                    .dashboardfooternav{
                        position:fixed;
                        bottom: 0;
                        width: 100%;
                        background:#252525;
                        border-top:1px solid #d5d5d5;
                        z-index: 2;
                    }

                }
                
            `}</style>
        </Nav>
    )
}

export default WellnessFooterNav